import React, { useEffect, useRef, useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { getStaticContent, updateStaticData } from '../services/commonServices';
import { useSnackbar } from 'notistack';

function TermsAndConditions() {
  const [staticDataTerms, setStaticDataTerms] = useState({});
  const [showEditorTerms, setShowEditorTerms] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const editorRefTerms = useRef(null);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    getContent();
    return () => {
      removeToolbarTerms();
    };
  }, []);

  useEffect(() => {
    if (showEditorTerms) {
      insertToolbarTerms();
    } else {
      removeToolbarTerms();
    }
  }, [showEditorTerms]);

  const getContent = async () => {
    const data = await getStaticContent();
    if (data?.data?.[0]) {
      // Keep only the field we edit here to avoid overwriting other static pages.
      delete data.data[0].aboutUs;
      delete data.data[0].privacyPolicy;
      setStaticDataTerms(data.data[0]);
    }
  };

  const handleSave = async () => {
    setIsLoading(true);
    const data = await updateStaticData(staticDataTerms);
    if (data && Object.prototype.hasOwnProperty.call(data, 'data')) {
      if (data.data?.aboutUs) delete data.data.aboutUs;
      if (data.data?.privacyPolicy) delete data.data.privacyPolicy;
      setStaticDataTerms(data.data);
      setShowEditorTerms(false);
    } else {
      enqueueSnackbar('Please remove whitespace!', {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'top' },
      });
    }
    setIsLoading(false);
  };

  const handleEditClick = () => {
    setShowEditorTerms(true);
  };

  const editorConfiguration = {
    toolbar: [
      'heading',
      '|',
      'bold',
      'italic',
      '|',
      'fontSize',
      '|',
      'numberedList',
      'bulletedList',
      '|',
      'undo',
      'redo',
    ],
  };

  const insertToolbarTerms = () => {
    const editor = editorRefTerms.current;
    if (
      editor &&
      editor.ui &&
      editor.ui.view &&
      editor.ui.getEditableElement() &&
      editor.ui.getEditableElement().parentElement
    ) {
      const toolbarParent = editor.ui.getEditableElement().parentElement;
      toolbarParent.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    }
  };

  const removeToolbarTerms = () => {
    const editor = editorRefTerms.current;
    if (editor && editor.ui.view.toolbar) {
      editor.ui.view.toolbar.element.remove();
    }
  };

  return (
    <div style={{ overflow: 'hidden' }}>
      <div className='d-flex justify-content-between mb-2'>
        <h2>Terms &amp; Conditions</h2>
        {showEditorTerms ? (
          <button
            style={{
              width: '100px',
              border: '1px solid whitesmoke',
              borderRadius: '10px',
              color: 'white',
              backgroundColor: '#1F6566',
            }}
            onClick={handleSave}
            disabled={isLoading}
          >
            {isLoading ? 'Saving...' : 'Save'}
          </button>
        ) : (
          <button
            style={{
              width: '100px',
              border: '1px solid whitesmoke',
              borderRadius: '10px',
              color: 'white',
              backgroundColor: '#1F6566',
            }}
            onClick={handleEditClick}
          >
            Edit
          </button>
        )}
      </div>

      <div style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 150px)', padding: '5px' }}>
        {showEditorTerms ? (
          <CKEditor
            editor={DecoupledEditor}
            data={staticDataTerms.termsAndConditions || ''}
            config={editorConfiguration}
            onReady={(editor) => {
              editorRefTerms.current = editor;
              insertToolbarTerms();
            }}
            onChange={(event, editor) => {
              setStaticDataTerms({ ...staticDataTerms, termsAndConditions: editor.getData() });
            }}
          />
        ) : (
          <div
            dangerouslySetInnerHTML={{ __html: staticDataTerms.termsAndConditions || '' }}
            className='staticData'
          />
        )}
      </div>
    </div>
  );
}

export default TermsAndConditions;

